export const RECAP_PROD: string       = '6LelEFwhAAAAAMtVkc1dX4CvHogY5VuSm6_Vu_Lg';
export const RECAP_LOCAL: string      = '6LdGAs0fAAAAAIoDWeaapLYTVmGAh-oqpc0rx151';
export const RECAP_STAGE: string      = '6Ld1D1whAAAAAIzbwYmmNWXQ2D6-jH6S5BlB2RgJ';
